import { ArrowRight } from 'lucide-react';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { useT } from '../../../i18n';
import type { BuilderWorkspace } from '../types';
import type { BuilderWorkspaceMeta } from '../workspaces';
import './MobileActionBar.css';

interface MobileActionBarProps {
  activeWorkspace: BuilderWorkspace;
  activeWorkspaceMeta: BuilderWorkspaceMeta;
  nextWorkspaceMeta: BuilderWorkspaceMeta | null;
  onSetActiveWorkspace: (workspace: BuilderWorkspace) => void;
}

/** Mobile progression for list workspaces. The toolbar owns Save;
 * design and build own their contextual navigation. */
export function MobileActionBar({
  activeWorkspace,
  activeWorkspaceMeta,
  nextWorkspaceMeta,
  onSetActiveWorkspace,
}: MobileActionBarProps) {
  const isMobile = useIsMobile();
  const t = useT();
  if (!isMobile) return null;

  if (activeWorkspace === 'design' || activeWorkspace === 'build' || activeWorkspace === 'rules') return null;

  if (nextWorkspaceMeta && activeWorkspaceMeta.nextLabel) {
    return (
      <div className="builder-mobile-action-bar" role="toolbar" aria-label={t.toolbar_buildHeading}>
        <button
          type="button"
          className="builder-mobile-action-bar__btn builder-mobile-action-bar__btn--primary builder-mobile-action-bar__btn--full"
          onClick={() => onSetActiveWorkspace(nextWorkspaceMeta.id)}
        >
          <span>{activeWorkspaceMeta.nextLabel}</span>
          <ArrowRight size={16} strokeWidth={2} aria-hidden="true" />
        </button>
      </div>
    );
  }

  return null;
}
